import React, { useState } from "react";
import { Card, Collapse } from "react-bootstrap";
import { ChevronDown, ChevronUp } from "react-bootstrap-icons";

const HowToExport = ({ isMobile = false }) => {
  const [showHowToExport, setShowHowToExport] = useState(!isMobile); // Default to collapsed on mobile, expanded on desktop

  // Toggle how to export section
  const toggleHowToExport = () => {
    setShowHowToExport(!showHowToExport);
  };

  return (
    <Card className="how-to-card">
      <Card.Header className="how-to-header" onClick={toggleHowToExport}>
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="how-to-title">How to Export from Spectora</h5>
          <div className="chevron-icon">
            {showHowToExport ? (
              <ChevronUp size={18} />
            ) : (
              <ChevronDown size={18} />
            )}
          </div>
        </div>
      </Card.Header>

      <Collapse in={showHowToExport}>
        <Card.Body className="how-to-body">
          <ol className="how-to-steps">
            <li>
              Go to{" "}
              <a
                target="_blank"
                rel="noreferrer"
                href="https://app.spectora.com/login"
                className="step-link"
              >
                Spectora Template Edit Page
              </a>{" "}
              &gt; My Templates
            </li>
            <li>Select the template you wish to export.</li>
            <li>Click the three dots in the upper-right</li>
            <li>Click Export to spreadsheet &gt; Export Plain Text</li>
            <li>Download the File</li>
          </ol>

          <a
            target="_blank"
            rel="noreferrer"
            href="https://support.spectora.com/en/articles/2769896-how-to-export-a-template"
            className="detailed-guide-link"
          >
            View detailed guide →
          </a>
        </Card.Body>
      </Collapse>
    </Card>
  );
};

export default HowToExport;
